import { calculatePercentage } from '../../common';
import { ProjectsReportRecord } from '../../types';
import { WidgetState } from '../state';
import { WidgetStateError } from './use-widget-data';

export const getProjectsEndedOnTime = (
  records: ProjectsReportRecord[],
): WidgetState<number, WidgetStateError> => {
  const projectsThatHasEndingDelay = records.filter(
    (x) => x.endingDelay != null,
  );

  if (projectsThatHasEndingDelay.length === 0) {
    return WidgetState.noData();
  }

  const projectsWithoutEndingDelay = projectsThatHasEndingDelay.filter(
    (x) => x.endingDelay != null && x.endingDelay <= 0,
  );

  const projectsEndingOnTime = calculatePercentage(
    projectsWithoutEndingDelay.length,
    projectsThatHasEndingDelay.length,
  );

  return WidgetState.data(projectsEndingOnTime);
};
